import React from "react";
import moment from "moment";
import { useTranslation } from "react-i18next";

const EpisodePreviewModal = ({
  activeEpisode,
  podcastDetails,
  open,
  setModalOpen,
}) => {
  const { t } = useTranslation();

  const displayDate = activeEpisode?.release_date
    ? moment(activeEpisode.release_date).format("MMM D")
    : t("episodeForm.previewFallbackDate");

  return (
    <div className={`demo-player-container-modal ${open ? "open" : ""}`}>
      <div className="demo-backdrop" onClick={() => setModalOpen(false)} />
      <div className="demo-player">
        <div className="d-flex justify-content-between align-items-start">
          <div>
            <h1>
              {activeEpisode?.title ||
                `[${t("episodeForm.previewFallbackEpisodeName")}]`}
            </h1>
            <h2>
              {podcastDetails?.title ||
                `[${t("episodeForm.previewFallbackPodcastName")}]`}
            </h2>
          </div>

          {podcastDetails?.image_url ? (
            <img
              className="artwork"
              src={podcastDetails.image_url}
              alt="Artwork"
            />
          ) : (
            t("episodeForm.previewFallbackImageUrl")
          )}
        </div>
        <p>
          {displayDate} ·{" "}
          {activeEpisode?.release_time || t("episodeForm.previewFallbackTime")}
        </p>
        <p className="subtitle">
          {activeEpisode?.subtitle || t("episodeForm.previewFallbackSubtitle")}
        </p>
        <div className="description">
          <p>
            {open && activeEpisode?.file_url ? (
              <audio controls>
                <source src={activeEpisode.file_url} type="audio/mpeg" />
              </audio>
            ) : (
              t("episodeForm.previewFallbackFileURL")
            )}
          </p>
          {activeEpisode?.description ? (
            <div
              dangerouslySetInnerHTML={{
                __html: activeEpisode?.description,
              }}
              className="description-container"
            ></div>
          ) : (
            <p>{t("episodeForm.previewFallbackDescription")}</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default EpisodePreviewModal;
